import { render, staticRenderFns } from "./VdSettingView.vue?vue&type=template&id=8f10a17c&scoped=true"
import script from "./VdSettingView.vue?vue&type=script&lang=ts"
export * from "./VdSettingView.vue?vue&type=script&lang=ts"
import style0 from "./VdSettingView.vue?vue&type=style&index=0&id=8f10a17c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f10a17c",
  null
  
)

export default component.exports